import { openPopupHelper } from 'reactApp/modules/popup/popup.helpers';
import { popupNames } from 'reactApp/modules/popup/popup.types';

export const renderDownloadAppModal = (onClose?: Parameters<typeof openPopupHelper>[0]['onClose']) =>
    openPopupHelper({ popupName: popupNames.MOBILE_DOWNLOAD_APP, onClose });
